export enum CostType {
	ServiceCharge = 1,
	Others
}